import { createCanvas } from '@/utils/helpers/train-simulation/create-canvas';
import { drawPath } from '@/utils/helpers/train-simulation/draw-path';

export const createPillAtlas = (w: number, h: number): string => {
  const res = createCanvas(w * 2, h * 2);

  if (!res || !res.ctx) {
    return '';
  }

  const { ctx, canvas } = res;

  const width = canvas.width;
  const height = canvas.height;
  const radius = height / 2;

  const path = new Path2D();
  path.moveTo(radius, 0);
  path.lineTo(width - radius, 0);
  path.quadraticCurveTo(width, 0, width, radius);
  path.lineTo(width, height - radius);
  path.quadraticCurveTo(width, height, width - radius, height);
  path.lineTo(radius, height);
  path.quadraticCurveTo(0, height, 0, height - radius);
  path.lineTo(0, radius);
  path.quadraticCurveTo(0, 0, radius, 0);
  path.closePath();

  drawPath(ctx, path, { fill: '#FFFFFF' });

  return canvas.toDataURL();
};
